import { Award, BookOpen, Heart, Users } from "lucide-react";

const TargetAudienceComponent = () => {
  return (
    <section className="py-12 px-4 custom-bg-color-02">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-3xl font-bold text-center mb-12 custom-color-01">
          Este congresso é para quem deseja servir com excelência e fidelidade
          bíblica
        </h3>

        <div className="grid md:grid-cols-2 gap-8 custom-color-01">
          <div className="space-y-6">
            <div className="flex items-start gap-3">
              <Users className="w-6 h-6 mt-1 flex-shrink-0 custom-color-05" />
              <span>
                Pastores, líderes ministeriais e conselheiros que buscam
                aprofundamento prático e teológico
              </span>
            </div>
            <div className="flex items-start gap-3">
              <Heart className="w-6 h-6 mt-1 flex-shrink-0 custom-color-05" />
              <span>
                Estudantes de teologia e membros ativos que desejam ser
                instrumentos de transformação
              </span>
            </div>
          </div>
          <div className="space-y-6">
            <div className="flex items-start gap-3">
              <Award className="w-6 h-6 mt-1 flex-shrink-0 custom-color-05" />
              <span>
                Quem já tentou outras abordagens e não encontrou resultados
                duradouros
              </span>
            </div>
            <div className="flex items-start gap-3">
              <BookOpen className="w-6 h-6 mt-1 flex-shrink-0 custom-color-05" />
              <span>
                Quem valoriza a suficiência das Escrituras e deseja aplicá-la de
                forma relevante
              </span>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 rounded-2xl border custom-bg-color-01 custom-border-color-05">
          <p className="text-center font-medium custom-color-03">
            Não é necessário ter formação teológica prévia. O conteúdo é
            acessível e aplicável a todos os cristãos comprometidos.
          </p>
        </div>
      </div>
    </section>
  );
};
export default TargetAudienceComponent;
